module.exports = "/_next/static/images/Logo_NBCSports_Front-9c4984c09df864f5d19302ab6532f31a.svg";